const productSetStore = ({
    namespaced: true,
    actions: {
        async getProductSetsbyProductCatalogId ({rootState}: {rootState: any}, search: string) {
            return new Promise ((resolve, reject) => {
                rootState.facebookMarketingFactory.GetProductSetsbyProductCatalogId(search)
                .then((response : any) => {
                    resolve(response);
                }, (error : any) => {
                    reject(error);
                })
            })
        }
    }
})

export default productSetStore